import * as React from 'react';

const Star = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width={19} height={18} viewBox="0 0 19 18" {...props}>
        <path
            fill="currentColor"
            fillRule="evenodd"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1.012}
            d="m9.983.834 2.51 4.972 4.83.479a.604.604 0 0 1 .375 1.03l-3.975 3.94 1.473 5.353a.61.61 0 0 1-.863.702l-4.897-2.425-4.89 2.422a.61.61 0 0 1-.863-.702l1.474-5.353-3.978-3.94a.604.604 0 0 1 .375-1.03l4.83-.479L8.89.834a.614.614 0 0 1 1.093 0"
        />
    </svg>
);
export default Star;
